import React from 'react';
import { Card } from '../ui/Card';
import { StarIcon } from 'lucide-react';
export const Testimonials = () => {
  const testimonials = [{
    quote: 'ZERO TO TEN helped us launch our AI-driven MVP in half the time. Our dedicated PM built an AI-powered onboarding prototype in 3 weeks that increased conversion by 15%.',
    author: 'Sarah Johnson',
    position: 'CTO, MarTech Startup',
    rating: 5,
    image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&auto=format&fit=crop&w=256&q=80',
    metrics: 'Prototype to MVP in 4 weeks • +35% conversion rate'
  }, {
    quote: 'Having a fractional PM with AI expertise has been a game-changer for our small team. They created a working prototype of our recommendation engine that we could test with users in just 10 days.',
    author: 'Michael Chen',
    position: 'Founder, SaaS Platform',
    rating: 5,
    image: 'https://images.unsplash.com/photo-1560250097-0b93528c311a?ixlib=rb-1.2.1&auto=format&fit=crop&w=256&q=80',
    metrics: 'AI prototype in 10 days • 28% increase in user engagement'
  }, {
    quote: 'Our ZERO TO TEN product manager integrated with our team seamlessly and used tools to analyze customer data that led to three new feature ideas we never would have considered.',
    author: 'Jessica Williams',
    position: 'VP Product, HRTech Platform',
    rating: 5,
    image: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?ixlib=rb-1.2.1&auto=format&fit=crop&w=256&q=80',
    metrics: 'AI data analysis • 3 new revenue-generating features'
  }];
  return <section id="testimonials" className="py-20 bg-purple-50 relative overflow-hidden" data-id="element-766">
      {/* Background pattern elements */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-purple-100 rounded-full opacity-40 -mr-48 -mt-48" data-id="element-767"></div>
      <div className="absolute bottom-0 left-0 w-80 h-80 bg-purple-100 rounded-full opacity-30 -ml-40 -mb-40" data-id="element-768"></div>
      <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-769">
        <div className="text-center mb-16" data-id="element-770">
          <h2 className="text-4xl md:text-5xl font-bold mb-4 text-black" data-id="element-771">
            Seize Your Strategic Opportunities
          </h2>
          <p className="text-xl text-text-secondary max-w-2xl mx-auto" data-id="element-772">
            Don't take our word for it - hear from the companies we've helped
            succeed with AI-powered product management.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto" data-id="element-773">
          {testimonials.map((testimonial, index) => <Card key={index} className="flex flex-col h-full" data-id="element-774">
              <div className="flex mb-4" data-id="element-775">
                {[...Array(testimonial.rating)].map((_, i) => <StarIcon key={i} className="w-5 h-5 text-yellow-400 fill-current" data-id="element-776" />)}
              </div>
              <blockquote className="font-serif text-text-secondary italic mb-6 flex-grow" data-id="element-777">
                "{testimonial.quote}"
              </blockquote>
              <div className="mt-2 mb-4" data-id="element-778">
                <span className="inline-block bg-purple-100 text-primary px-3 py-1 rounded-full text-xs font-medium" data-id="element-779">
                  {testimonial.metrics}
                </span>
              </div>
              <div className="mt-auto" data-id="element-780">
                <p className="text-sm text-text-secondary font-medium" data-id="element-781">
                  {testimonial.position}
                </p>
              </div>
            </Card>)}
        </div>
      </div>
    </section>;
};